import { useEffect } from "react";

type SeoProps = {
  title: string;
  description: string;
  keywords?: string;
  jsonLd?: object[];
};

export default function Seo({ title, description, keywords, jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;

    const upsert = (selector: string, attr: string, value: string) => {
      let el = document.head.querySelector(selector) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, "");
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    upsert('meta[name="description"]', "name", description);
    if (keywords) {
      upsert('meta[name="keywords"]', "name", keywords);
    }

    // clear previous json-ld
    document.head
      .querySelectorAll("script[data-seo-ld]")
      .forEach((n) => n.remove());
    if (jsonLd && jsonLd.length) {
      jsonLd.forEach((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-seo-ld", "");
        s.textContent = JSON.stringify(obj);
        document.head.appendChild(s);
      });
    }
  }, [title, description, keywords, jsonLd]);

  return null;
}